
import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import Vue from "vue";
import Component from "vue-class-component";
import { Format } from "../core/helpers/formatHelper";
import store from "../core/store";
import { BookingConcept } from "@shared/crm/constants";
import BookingTypeCard from "@shared/components/bookingType/bookingTypeCard.vue";
import Navigation from "@shared/components/navigation/navigation.vue";
import VerticalScrollList from "@shared/crm/components/verticalScrollList.vue";

@Component({
  components: {
    BookingTypeCard,
    Navigation,
    VerticalScrollList,
  },
})
export default class BookingTypesPage extends Vue {
  dbBookingTypes: any = null;
  bookingTypes: any = null;
  errorMsg: string = "";
  categories: string[] = [];
  selectedCategory: string | null = null;

  async mounted() {
    const url = `${Settings.HostName}/api/publicbookings/booking-types-list`;
    const data = await new CrudService().httpGet(url);
    if (data == null || data.model == null || !data.ok) {
      console.error("Crash getting index booking types");
      return;
    }

    this.bookingTypes = data.model;

    const queryConceptMap = new Map<string, Number>([
      ["bookings", BookingConcept.Booking],
      ["matches", BookingConcept.Match],
      ["school", BookingConcept.School],
      ["events", BookingConcept.Event],
    ]);

    var queries = Object.keys(this.$route.query);
    if (queries.length > 0) {
      const concept = queryConceptMap.get(Object.keys(this.$route.query)[0]);
      this.bookingTypes = this.bookingTypes.filter(
        (y) => y.concept === concept
      );
    }

    this.dbBookingTypes = data.model;
    if (this.dbBookingTypes.length === 1) {
      this.$router.push(this.buildUrlBooking(this.dbBookingTypes[0]));
      return;
    }

    this.setUpCategories();
  }

  setUpCategories() {
    for (const bt of this.dbBookingTypes) {
      if (bt.category == null || bt.category.trim() === "") {
        continue;
      }

      if (
        this.categories.find(
          (y) => y.toLowerCase() == bt.category.toLowerCase()
        ) == undefined
      ) {
        this.categories.push(bt.category);
      }
    }
  }

  getImagePath(img: string) {
    if (img === null || img === undefined || img === "") {
      return (
        this.$store.state.settings.Uploads +
        "/" +
        this.$store.state.settings.Mainlogo
      );
    }
    return this.$store.state.settings.Uploads + "/" + img;
  }

  buildUrlBooking(bt: any) {
    if (bt.bookingByPlace === true) {
      return `/bookings-byplace/${bt.id}`;
    }
    return `/bookings/${bt.id}`;
  }

  filterByCategory(cat: string | null) {
    this.selectedCategory = cat;

    if (cat === null) {
      this.bookingTypes = this.dbBookingTypes;
    } else {
      this.bookingTypes = this.dbBookingTypes.filter(
        (y) => y.category && y.category.toLowerCase() === cat.toLowerCase()
      );
    }
  }

  getPrice(pr: any) {
    return this.formatText(
      store.state.settings.PriceWithTaxes ? pr.grossPrice : pr.netPrice
    );
  }

  formatText(amount: string | null) {
    if (amount == null) {
      return "   ";
    }
    return this.$t("From") + " " + Format.formatCurrency(amount as string);
  }
}
